import styled from 'styled-components';
import { colourPalette, cssScreens } from 'styles/styles';

export const TopBarCreditsStyle = {
  Credits: styled.p`
    min-width: fit-content;
    padding-left: 13px;
    color: ${colourPalette.neutral500};
    margin: 0;

    @media screen and (max-width: ${cssScreens.tabletLarge}) {
      display: none;
    }
  `,
  CreditsLink: styled.span`
    color: ${colourPalette.neutral900};
    font-weight: 400;
    &.link-to-credits-enabled {
      cursor: pointer;
    }
  `,
};
